export default {
  placeholderOrderNo: 'Masukkan Nomor Pesanan / Kiriman',
}
